<template>
    <div class="row">
        <div class="col-12">
            <div class="accordion" id="featureViewer">
                <div class="card"
                    v-for="(item, idx) in itemData"
                    :key="`card-${idx}`">

                    <div class="card-header" :id="`heading-${idx}`">
                        <button
                            class="btn btn-block text-left z-depth-0"
                            type="button"
                            data-toggle="collapse"
                            :data-target="`#collapse-${idx}`"
                            :aria-expanded="idx==0"
                            :aria-controls="`collapse-${idx}`">
                            {{ item.name }}
                        </button>
                    </div>
                    <div :id="`collapse-${idx}`"
                        class="collapse"
                        :class="{'show': idx == 0}"
                        :aria-labelledby="`heading-${idx}`"
                        data-parent="#featureViewer">
                        <div class="card-body p-0" :class="{'px-0': !item.name}">
                            <group-element
                                :id="idx"
                                :item="item.items" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewerMixin from './../ViewerMixin';

export default
{
    name: 'AccordionViewer',
    mixins: [
        ViewerMixin,
    ],
    components: {
        GroupElement: () => import(/* webpackChunkName: "viewer-group-element" */ './../elements/GroupElement'),
    },
    props: {
        data: {
            type: Object,
            require: true,
        },
    },
    data() {
        return {

        }
    },
    computed: {

    },
}

</script>